import { Account } from '../models/account';

export const accountsReducer = (state: Account[] = []) => {
    return state;
};
